module.exports = __webpack_public_path__ + "static/EnmTX_BosWerner_L_B_cl-66bb487950a2256f4ebd92e806a9e8cb.gif";